import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import leftArrow from '../assets/images/left-arrow.svg';
import { onFinishedWebView, sendFirebaseEvent } from '../helper/mobile';

const Header = ({title, isBookingNavDisplay, howToMeasure}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const goBackClickHandler = () => {
    if(location.pathname === '/')
     onFinishedWebView();
    else if(location.pathname.includes('bookingTimeLine'))
      onFinishedWebView();
    else if(location.pathname === '/riskAssessment/list')
      onFinishedWebView();
    else if(location.pathname.includes('paidQuestion'))
      onFinishedWebView();
    else
      navigate(-1);
  }

  return(
    <div className="d-flex align-items-start align-items-center header">
      <img src={leftArrow} alt='' onClick={goBackClickHandler} />
      <div className='w-100 overflow-hidden'>
        { isBookingNavDisplay && <Link to="/mybooking" className="link float-end">My bookings</Link> }
        { howToMeasure && <Link to="/riskAssessment/measure" className="link float-end measure-link" onClick={() => sendFirebaseEvent('ra_how_we_measure_link_click', 'click_event')}>How we measure?</Link>}
        <h3 className="mt-0 mb-0">{title}</h3>
      </div>
    </div>
  );
}

export default Header;